import React, {useState} from "react";
import ReactApexChart from 'react-apexcharts'

function DistributionChart(props) {
      
      const arrayOfArrays=[props.proportion]
      const allProportions = [];
      const [series, setseries]= useState();
      for (const array of arrayOfArrays) {
        const proportions = array.map((item) => item.proportion);
        allProportions.push(proportions);
      }

       const [count, setCount] = useState({
          series: allProportions[0],
          options: {
            dataLabels: {
              enabled: false
            },
            toolbar: {
              show: false
          },
          legend: {
            show: false
          },
          },
        });
        
      
      return (
  <div id="chart">
  <ReactApexChart options={count.options} series={count.series} type="pie" width={230} height={140}/>
   </div>
      )


}

export default DistributionChart;